import { useQuery } from '@apollo/client';
import { FontDownload } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { NetworkFontAuditLogsDocument } from '../queries/AuditLogs.generated';
import { useTabs } from './lib/tabs';

export const FontAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ fontId: string }>();
  const fontId = parseInt(params.fontId ?? '');

  const { currentNetwork } = useAppContext();
  const link = useLink();

  const tabs = useTabs();

  const { data, loading } = useQuery(NetworkFontAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, fontId },
  });

  const font = data?.network?.font;

  if (loading || !font) return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<FontDownload />}
        titleText={font.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['Font']} fontId={fontId} />
      </PageContainer>
    </>
  );
};
